export enum NexdosSecondaryColorEnum {
  TEAL_PPT_1 = '#ff8945',
  TEAL_PPT_2 = '#a1803c',
  TEAL_PPT_3 = '#94b0b2',
  TEAL_PPT_4 = '#a63b00',
  TEAL_PPT_5 = '#00c9dc',
  TEAL_PPT_6 = '#229399',
  TEAL_PPT_7 = '#00825c',
  TEAL_PPT_8 = '#324b4c',
  TEAL_PPT_9 = '#002d34'
}
